<template>
  <q-card>
    <q-form @submit.prevent="add">
      <q-card-section>
        <div class="text-h6">Новый тип задач</div>
      </q-card-section>
      <q-card-section class="q-pt-none">
        <q-input dense v-model="newTaskType.name" label="Имя" :rules="[requiredRule]" />
        <q-input dense v-model="newTaskType.description" type="textarea" label="Описание" />
      </q-card-section>

      <q-card-actions align="right" class="text-primary">
        <q-btn no-caps flat label="Добавить" type="submit" />
      </q-card-actions>
    </q-form>
  </q-card>
</template>

<script setup lang="ts">
import { NewTaskType } from "../models/task";
import { computed, reactive } from "vue";
import { requiredRule } from "../util/rules";
import { useRoute, useRouter } from "vue-router";
import { useAddTaskTypes } from "../composables/task";
import { useTaskTypesStore } from "../store/taskTypes";

const route = useRoute()
const router = useRouter()

const projectId = computed(() => Number(route.params.projectId))

const newTaskType: NewTaskType = reactive({
  name: "",
  description: ""
})



const store = useTaskTypesStore()
const { execute } = useAddTaskTypes(projectId, newTaskType)

async function add() {
  await execute()
  await store.select(projectId)
  const id = store.taskTypes.sort((a, b) => b.id - a.id)[0].id
  await router.push(`/projects/${projectId.value}/settings/taskType/${id}`)
}
</script>

<style scoped></style>